var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63314 9.05841C7.5498 9.05008 7.4498 9.05008 7.35814 9.05841C5.3748 8.99175 3.7998 7.36675 3.7998 5.36675C3.7998 3.32508 5.4498 1.66675 7.4998 1.66675C9.54147 1.66675 11.1998 3.32508 11.1998 5.36675C11.1915 7.36675 9.61647 8.99175 7.63314 9.05841Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6738 3.33325C15.2904 3.33325 16.5904 4.64159 16.5904 6.24992C16.5904 7.82492 15.3404 9.10825 13.7821 9.16659C13.7154 9.15825 13.6404 9.15825 13.5654 9.16659",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46758 12.1333C1.45091 13.4833 1.45091 15.6833 3.46758 17.0249C5.75924 18.5583 9.51758 18.5583 11.8092 17.0249C13.8259 15.6749 13.8259 13.4749 11.8092 12.1333C9.52591 10.6083 5.76758 10.6083 3.46758 12.1333Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2822 16.6667C15.8822 16.5417 16.4489 16.3001 16.9156 15.9417C18.2156 14.9667 18.2156 13.3584 16.9156 12.3834C16.4572 12.0334 15.8989 11.8001 15.3072 11.6667",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientManagement);
export default __webpack_public_path__ + "static/media/client_management.7a5f2f5a7f9d195df521b7d918e4139d.svg";
export { ForwardRef as ReactComponent };